import React from 'react';
import {Map} from 'immutable';
import PassageCorrectionQuestionEditor from './PassageCorrectionEditor/PassageCorrectionEditor.react';
import PassageCorrectionQuestion from './PassageCorrectionQuestion/PassageCorrectionQuestion.react';
import PassageCorrectionExplanation from './PassageCorrectionQuestion/PassageCorrectionExplanation.react';

/**
 * @todo: Make a generic response stats component that returns
 * percentage correct / percentage incorrect and use that here
 */
class PassageCorrectionResponseStats extends React.Component {
  render() {
    return null;
  }
}

const PassageCorrectionQuestionType = Map({
  type: 'passage-correction',
  label: 'Passage Correction',
  questionRenderer: PassageCorrectionQuestion, // New IE renderer
  explanationRenderer: PassageCorrectionExplanation,
  responseStatsRenderer: PassageCorrectionResponseStats,
  editor: PassageCorrectionQuestionEditor,
  isHidden: false
});

export default PassageCorrectionQuestionType;
